import React from 'react';
import { Page } from '../components/Page';
import { PageHeader } from '../components/PageHeader';

export const FoodDiary = () => {
  return (
    <Page>
      <PageHeader title="Matardagbók" />
    </Page>
  );
};
